import {createSelector} from 'reselect';

const roomMessagesSelector = state => state.roomMessages;
const roomIdSelector = (_, _id) => _id;

export const roomMessagesByRoomId = createSelector(
    roomMessagesSelector,
    roomIdSelector,
    (message, key) => message[key] || message['default']
);

export const roomMessagesKeysByRoomId = createSelector(
    roomMessagesSelector,
    (message, roomId) => Object.values(message).filter((message) => message.roomId === roomId)
);